<h2 mat-dialog-title>Засчитать промокод</h2>

<mat-dialog-content [formGroup]="form">
  <p>
    Будут выданы все награды и, если предусмотрено, начислен отыгрыш по промокоду
    <strong>{{ data.code }}</strong>.
  </p>

  <mat-form-field appearance="outline" class="deposit-field">
    <mat-label>Сумма депозита, F-коины (×100)</mat-label>
    <input
      matInput
      type="number"
      step="1"
      formControlName="depositAmount"
      [min]="data.minDepositSum"
    />
    <mat-hint>
      Минимум для этого промокода: {{ data.minDepositSum }}
    </mat-hint>
    <mat-error *ngIf="form.get('depositAmount')?.hasError('min')">
      Сумма меньше минимального депозита — при таком депозите промокод
      пользователю не положен.
    </mat-error>
    <mat-error *ngIf="form.get('depositAmount')?.hasError('required')">
      Укажите сумму депозита.
    </mat-error>
    <mat-error *ngIf="form.get('depositAmount')?.hasError('pattern')">
      Сумма должна быть целым числом.
    </mat-error>
  </mat-form-field>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button type="button" (click)="cancel()">Отмена</button>
  <button
    mat-raised-button
    color="primary"
    type="button"
    [disabled]="form.invalid"
    (click)="submit()"
  >
    Засчитать промокод
  </button>
</mat-dialog-actions>
